<ion-app>
  <ion-grid
    *ngIf="
      groupAppLoading ||
      !appInitLoadingStep ||
      appInitLoadingStep !== 'app-loaded' ||
      (groupApp &&
        groupApp.splash_screen_active &&
        groupApp.splashScreenImage &&
        !splashScreenDissmised)
    "
  >
    <ion-row
      class="ion-justify-content-center ion-align-items-center"
      style="width: 100%; height: 100%"
    >
      <ion-col class="ion-align-self-center">
        <ion-spinner color="dark"></ion-spinner>
      </ion-col>
    </ion-row>
  </ion-grid>

  <ion-split-pane
    *ngIf="
      groupApp &&
      groupTheme &&
      appInitLoadingStep &&
      appInitLoadingStep === 'app-loaded' &&
      !groupApp.only_loyalty_app &&
      !groupApp.active_reservation_app &&
      (!groupApp.splash_screen_active ||
        !groupApp.splashScreenImage ||
        (groupApp.splash_screen_active &&
          groupApp.splashScreenImage &&
          splashScreenDissmised))
    "
    class="spit-pane-width"
    contentId="main-content"
    [when]="menuMinWidthToDisplay"
  >
    <ion-menu
      *ngIf="selectedIndex"
      [swipeGesture]="false"
      class="side-menu"
      contentId="main-content"
      menuId="sideMenu"
      type="overlay"
      id="side-menu-ionic"
    >
      <ion-header>
        <ion-toolbar
          [ngClass]="{
            headerMenuBackgroundHeaderLogo:
              groupApp &&
              groupApp.design_settings &&
              groupApp.design_settings.sideMenuHeaderLogo &&
              groupApp.headerLogoIconBackground &&
              headerLogo &&
              selectedTheme &&
              (selectedTheme === 'light' ||
                (selectedTheme === 'dark' && !darkHeaderLogo)),
            headerMenuBackground:
              groupApp &&
              groupApp.design_settings &&
              groupApp.design_settings.sideMenuHeaderLogo &&
              !groupApp.headerLogoIconBackground &&
              headerLogo &&
              selectedTheme &&
              (selectedTheme === 'light' ||
                (selectedTheme === 'dark' && !darkHeaderLogo)),
            biggerToolBar:
              groupApp.design_settings &&
              groupApp.design_settings.sideMenuHeaderLogo &&
              headerLogo &&
              windowDimensions &&
              windowDimensions.width >= 800
          }"
        >
          <app-side-menu-header-logo
            [groupApp]="groupApp"
            [flattenedIconBackgroundFlag]="flattenedIconBackgroundFlag"
            [biggerImageLogo]="
              groupApp.design_settings &&
              groupApp.design_settings.sideMenuHeaderLogo &&
              headerLogo &&
              windowDimensions &&
              windowDimensions.width >= 800
                ? true
                : false
            "
            [storeImage]="storeImage"
            [headerLogo]="headerLogo"
            [darkHeaderLogo]="darkHeaderLogo"
            (click)="changeChannel()"
          ></app-side-menu-header-logo>
          <ion-button
            *ngIf="
              groupApp &&
              groupApp.flattenedIconBackground &&
              groupApp.design_settings &&
              groupApp.design_settings.sideMenuHeaderLogo &&
              headerLogo &&
              !sideMenuIsOpen
            "
            [class]="
              sideMenuCloseButtonCustomColor
                ? 'sideMenuCloseButtonCustomColor'
                : selectedTheme === 'dark' && !groupApp.headerLogoDark
                ? groupApp.headerLogoIconBackground
                  ? 'headerLogoIconBackgroundInverted'
                  : 'flattenedIconBackgroundInverted'
                : ((!groupApp.headerLogoIconBackground &&
                    groupApp.flattenedIconBackground === primaryColor) ||
                    (groupApp.headerLogoIconBackground &&
                      groupApp.headerLogoIconBackground === primaryColor)) &&
                  selectedTheme !== 'dark'
                ? 'primaryInverted'
                : ''
            "
            (click)="closeSideMenu()"
            slot="end"
            fill="clear"
          >
            <ion-icon src="assets/ionicons/close.svg"></ion-icon>
          </ion-button>

          <ion-button
            *ngIf="
              groupApp &&
              !groupApp.flattenedIconBackground &&
              groupApp.design_settings &&
              groupApp.design_settings.sideMenuHeaderLogo &&
              headerLogo &&
              !sideMenuIsOpen
            "
            (click)="closeSideMenu()"
            slot="end"
            fill="clear"
          >
            <ion-icon src="assets/ionicons/close.svg"></ion-icon>
          </ion-button>
          <ion-button
            color="dark"
            *ngIf="
              groupApp &&
              (!groupApp.design_settings ||
                !groupApp.design_settings.sideMenuHeaderLogo ||
                !headerLogo) &&
              !sideMenuIsOpen
            "
            (click)="closeSideMenu()"
            slot="end"
            fill="clear"
          >
            <ion-icon src="assets/ionicons/close.svg"></ion-icon>
          </ion-button>
        </ion-toolbar>
      </ion-header>
      <ion-content>
        <ion-list id="inbox-list" lines="none" style="padding: 0px">
          <ion-list-header
            [hidden]="
              currentUser &&
              (currentUser.only_dinein ||
                currentUser.only_visitor ||
                currentUser.uposMoUser)
            "
            *ngIf="currentUser"
            style="
              padding-left: 0;
              padding-right: 0;
              padding-top: 8px;
              padding-bottom: 8px;
            "
          >
            <ion-item
              (click)="closeSideMenuAndNavigateAccount()"
              button
              detail="false"
              [color]="
                selectedIndex === 'account-settings'
                  ? ''
                  : 'customSideMenuItemBackground'
              "
              [class]="
                selectedIndex === 'account-settings'
                  ? 'accountSettingsButton tintSelected'
                  : 'accountSettingsButton'
              "
              lines="none"
              style="width: 100%"
            >
              <ion-avatar slot="start"
                ><img
                  alt="user_avatar"
                  [src]="
                    menuProfileImageSrc
                      ? menuProfileImageSrc
                      : 'https://cdn.pixabay.com/photo/2016/08/08/09/17/avatar-1577909_960_720.png'
                  "
              /></ion-avatar>
              <ion-label
                *ngIf="
                  currentUser &&
                  (currentUser.firstName || currentUser.lastName) &&
                  currentUser.mobile
                "
                style="font-size: medium"
              >
                &nbsp;{{ currentUser.firstName ? currentUser.firstName : "" }}
                {{ currentUser.lastName ? currentUser.lastName : "" }}
                <div
                  style="font-size: small; opacity: 0.7"
                  *ngIf="currentUser.mobile"
                >
                  &nbsp;{{ currentUser.mobile }}
                </div>
              </ion-label>
              <ion-label
                *ngIf="
                  currentUser &&
                  !currentUser.firstName &&
                  !currentUser.lastName &&
                  currentUser.mobile
                "
                style="font-size: medium"
              >
                &nbsp;{{ currentUser.mobile }}
              </ion-label>
              <ion-button
                class="ion-no-padding"
                style="margin-left: 7px"
                slot="end"
                title="{{ 'edit' | translate }}"
                size="small"
                fill="clear"
              >
                <ion-icon
                  slot="icon-only"
                  src="assets/flatIcons/edit.svg"
                ></ion-icon>
              </ion-button>
            </ion-item>
          </ion-list-header>

          <ion-item
            *ngIf="
              currentUser &&
              currentUser.only_dinein &&
              orderPickup == false &&
              dinein == true &&
              selectedLanguage &&
              store_info &&
              selectedDineInTable.name
            "
            class="accountSettingsButton"
            color="deliveryMethodAddressButtons"
            lines="none"
            detail="false"
          >
            <ion-label class="ion-text-center" style="margin: 0; width: 100%">
              <ion-text
                class="ion-text-center"
                style="font-weight: bold; font-size: small"
              >
                {{ "popups.dine-in-modal.table" | dineinTableLabel: dineinTableContext }}:
                {{ selectedDineInTable.name }}
              </ion-text>
            </ion-label>
          </ion-item>

          <ion-item
            *ngIf="
              currentUser &&
              currentUser.uposMoUser &&
              (currentUser.fistName || currentUser.lastName)
            "
            class="accountSettingsButton"
            color="deliveryMethodAddressButtons"
            lines="none"
            detail="false"
          >
            <ion-label class="ion-text-center" style="margin: 0; width: 100%">
              <ion-text
                class="ion-text-center"
                style="font-weight: bold; font-size: small"
              >
                {{
                  currentUser.fistName
                    ? currentUser.fistName
                    : currentUser.lastName
                }}
              </ion-text>
            </ion-label>
          </ion-item>

          <ion-menu-toggle auto-hide="false">
            <ion-grid
              *ngIf="
                !loginState ||
                loginState === 'login_loading' ||
                (loginState === 'login_completed' && !currentUser)
              "
            >
              <ion-row style="width: 100%">
                <ion-col class="ion-text-center">
                  <ion-spinner> </ion-spinner>
                </ion-col>
              </ion-row>
            </ion-grid>
            <ion-list
              style="padding: 0"
              *ngIf="
                loginState &&
                (loginState === 'no_login' ||
                  (loginState === 'login_completed' &&
                    currentUser &&
                    !currentUser.only_dinein &&
                    !currentUser.only_visitor))
              "
            >
              <ion-item
                button
                (click)="pageChange('homepage')"
                lines="none"
                detail="false"
                [class.selected]="selectedIndex === 'homepage'"
                [color]="
                  selectedIndex === 'homepage'
                    ? ''
                    : 'customSideMenuItemBackground'
                "
              >
                <ion-icon
                  slot="start"
                  style="margin-right: 20px"
                  [ios]="'home' + '-outline'"
                  [md]="'home' + '-sharp'"
                >
                </ion-icon>
                <ion-label>{{ "pages.homepage" | translate }}</ion-label>
              </ion-item>
              <ion-item
                button
                *ngIf="cartProducts && cartProducts.length > 0"
                (click)="pageChange('cart')"
                lines="none"
                detail="false"
                [class.selected]="selectedIndex === 'cart'"
                [color]="
                  selectedIndex === 'cart' ? '' : 'customSideMenuItemBackground'
                "
              >
                <ion-icon
                  slot="start"
                  style="margin-right: 20px"
                  [ios]="'cart' + '-outline'"
                  [md]="'cart' + '-sharp'"
                >
                </ion-icon>
                <ion-label>
                  {{ "pages.cart" | translate }}
                </ion-label>
                <ion-badge
                  *ngIf="cartProductsNumber"
                  slot="end"
                  color="ionMenuBadgesColor"
                  >{{ cartProductsNumber }}</ion-badge
                >
              </ion-item>
              <!-- catalog -->
              <ion-item
                button
                *ngIf="
                  groupApp?.design_settings?.hideSideCatalogMenuButton !== true &&
                  ((stores && stores.length === 1) || currentStore) &&
                  ((currentStore && !currentStore.showOnlyFavoritesCatalog) ||
                    (currentStore &&
                      currentStore.showOnlyFavoritesCatalog &&
                      currentUser))
                "
                (click)="pageChange('catalog')"
                lines="none"
                detail="false"
                [class.selected]="selectedIndex === 'catalog'"
                [color]="
                  selectedIndex === 'catalog'
                    ? ''
                    : 'customSideMenuItemBackground'
                "
              >
                <ion-icon
                  slot="start"
                  style="margin-right: 20px"
                  [ios]="'list' + '-outline'"
                  [md]="'list' + '-sharp'"
                >
                </ion-icon>

                <ion-label>
                  <ion-text
                    *ngIf="
                      !groupApp.design_settings ||
                      !groupApp.design_settings
                        .sideCatalogMenuButtonCustomTextEnabled ||
                      (groupApp.design_settings &&
                        groupApp.design_settings
                          .sideCatalogMenuButtonCustomTextEnabled &&
                        (!groupApp.design_settings
                          .sideCatalogMenuButtonCustomText ||
                          !groupApp.design_settings
                            .sideCatalogMenuButtonCustomText[selectedLanguage]))
                    "
                  >
                    {{ "pages.catalog" | translate }}
                  </ion-text>

                  <ion-text
                    *ngIf="
                      groupApp.design_settings &&
                      groupApp.design_settings
                        .sideCatalogMenuButtonCustomTextEnabled &&
                      groupApp.design_settings
                        .sideCatalogMenuButtonCustomText &&
                      groupApp.design_settings.sideCatalogMenuButtonCustomText[
                        selectedLanguage
                      ]
                    "
                  >
                    {{
                      groupApp.design_settings.sideCatalogMenuButtonCustomText[
                        selectedLanguage
                      ]
                    }}
                  </ion-text>
                  <div
                    *ngIf="
                      stores &&
                      stores.length > 1 &&
                      currentStore &&
                      currentStore.store_name &&
                      selectedLanguage
                    "
                    style="font-size: small; opacity: 0.7"
                  >
                    <ion-text>
                      {{
                        currentStore.store_name_mobileorder &&
                        currentStore.store_name_mobileorder[selectedLanguage]
                          ? currentStore.store_name_mobileorder[
                              selectedLanguage
                            ]
                          : currentStore.store_name_langs &&
                            currentStore.store_name_langs[selectedLanguage]
                          ? currentStore.store_name_langs[selectedLanguage]
                          : currentStore.store_name_langs &&
                            currentStore.store_name_langs.el
                          ? currentStore.store_name_langs.el
                          : currentStore.store_name
                      }}
                    </ion-text>
                  </div>
                </ion-label>
              </ion-item>
              <!-- affiliate -->
              <ion-item
                *ngIf="
                  stores &&
                  groupApp &&
                  !store_info?.only_visitors_app &&
                  (groupApp.affiliateActive ||
                    (groupApp.affiliateProductionMode &&
                      currentUser &&
                      currentUser.mobile === '6945076868'))
                "
                (click)="pageChange('affiliate')"
                lines="none"
                button
                detail="false"
                [class.selected]="selectedIndex === 'affiliate'"
                [color]="
                  selectedIndex === 'affiliate'
                    ? ''
                    : 'customSideMenuItemBackground'
                "
                [hidden]="currentUser && currentUser.uposMoUser"
              >
                <ion-icon
                  slot="start"
                  style="margin-right: 20px"
                  [ios]="'megaphone' + '-outline'"
                  [md]="'megaphone' + '-sharp'"
                ></ion-icon>
                <ion-label>{{
                  groupApp.affiliateSideMenuTitle[selectedLanguage]
                }}</ion-label>
              </ion-item>
              <!-- kiosk -->
              <ion-item
                button
                *ngIf="
                  groupApp &&
                  !store_info?.only_visitors_app &&
                  (groupApp.pointsSystem || groupApp.couponsPage) &&
                  atLeastOneStoreKioskActive &&
                  !(
                    groupApp.design_settings &&
                    groupApp.design_settings.dm_kiosk_app_disable_mobileorder
                  )
                "
                (click)="pageChange('kiosk')"
                lines="none"
                detail="false"
                [class.selected]="selectedIndex === 'kiosk'"
                [color]="
                  selectedIndex === 'kiosk'
                    ? ''
                    : 'customSideMenuItemBackground'
                "
                [hidden]="currentUser && currentUser.uposMoUser"
              >
                <ion-icon
                  slot="start"
                  style="margin-right: 20px"
                  [ios]="'tablet-portrait' + '-outline'"
                  [md]="'tablet-portrait' + '-sharp'"
                ></ion-icon>
                <ion-label>{{ "pages.kiosk" | translate }}</ion-label>
              </ion-item>
              <!-- favorite products -->
              <ion-item
                *ngIf="
                  currentUser &&
                  ((stores && stores.length === 1) || currentStore) &&
                  currentStore &&
                  !currentStore.showOnlyFavoritesCatalog
                "
                button
                (click)="pageChange('favoriteProducts')"
                lines="none"
                detail="false"
                [class.selected]="selectedIndex === 'favoriteProducts'"
                [color]="
                  selectedIndex === 'favoriteProducts'
                    ? ''
                    : 'customSideMenuItemBackground'
                "
                [hidden]="currentUser && currentUser.uposMoUser"
              >
                <ion-icon
                  slot="start"
                  style="margin-right: 20px"
                  [ios]="'heart' + '-outline'"
                  [md]="'heart' + '-sharp'"
                >
                </ion-icon>
                <ion-label>{{ "pages.favorites" | translate }}</ion-label>
              </ion-item>
              <!-- orders -->
              <ion-item
                button
                *ngIf="currentUser"
                (click)="pageChange('orders')"
                lines="none"
                detail="false"
                [class.selected]="selectedIndex === 'orders'"
                [color]="
                  selectedIndex === 'orders'
                    ? ''
                    : 'customSideMenuItemBackground'
                "
              >
                <ion-icon
                  slot="start"
                  style="margin-right: 20px"
                  [ios]="'reader' + '-outline'"
                  [md]="'reader' + '-sharp'"
                ></ion-icon>
                <ion-label>{{ "pages.orders" | translate }}</ion-label>
              </ion-item>
              <!-- reservations -->
              <ion-item
                button
                *ngIf="
                  !store_info?.only_visitors_app &&
                  currentStore &&
                  currentStore.reservationMobileorderActive
                "
                (click)="pageChange('reservations')"
                lines="none"
                detail="false"
                [class.selected]="selectedIndex === 'reservations'"
                [color]="
                  selectedIndex === 'reservations'
                    ? ''
                    : 'customSideMenuItemBackground'
                "
                [hidden]="currentUser && currentUser.uposMoUser"
              >
                <ion-icon
                  style="margin-right: 20px"
                  slot="start"
                  [ios]="'calendar' + '-outline'"
                  [md]="'calendar' + '-sharp'"
                ></ion-icon>
                <ion-label>{{ "pages.reservations" | translate }}</ion-label>
              </ion-item>
              <!-- payment-cards -->
              <ion-item
                button
                *ngIf="
                  currentUser &&
                  !store_info?.only_visitors_app &&
                  (showPaymentCards ||
                    (currentUser.admin && showPaymentCardsAdminOnly) ||
                    showPaymentCardsCustomerOnly)
                "
                (click)="pageChange('payment-cards')"
                lines="none"
                detail="false"
                [class.selected]="selectedIndex === 'payment-cards'"
                [color]="
                  selectedIndex === 'payment-cards'
                    ? ''
                    : 'customSideMenuItemBackground'
                "
              >
                <ion-icon
                  slot="start"
                  style="margin-right: 20px"
                  [ios]="'card' + '-outline'"
                  [md]="'card' + '-sharp'"
                >
                </ion-icon>
                <ion-label>{{ "pages.payment-cards" | translate }}</ion-label>
              </ion-item>
              <!-- points -->
              <ion-item
                button
                *ngIf="
                  groupApp &&
                  groupApp.pointsSystem &&
                  !store_info?.only_visitors_app
                "
                (click)="pageChange('points')"
                lines="none"
                detail="false"
                [class.selected]="selectedIndex === 'points'"
                [color]="
                  selectedIndex === 'points'
                    ? ''
                    : 'customSideMenuItemBackground'
                "
                [hidden]="currentUser && currentUser.uposMoUser"
              >
                <ion-icon
                  slot="start"
                  style="margin-right: 20px"
                  [ios]="'gift' + '-outline'"
                  [md]="'gift' + '-sharp'"
                >
                </ion-icon>
                <ion-label
                  >{{ "pages.points" | translate }}
                  <div
                    style="
                      position: absolute;
                      bottom: 5px;
                      z-index: 100;
                      height: 3px;
                      width: 100%;
                    "
                    *ngIf="
                      currentUser &&
                      userPoints &&
                      highestReward &&
                      highestReward.user_points_percent &&
                      userPoints.pointsSystem &&
                      userPoints.pointsSystem.active > 0
                    "
                  >
                    <ion-progress-bar
                      [color]="pointsProgressBarColor"
                      [value]="highestReward.user_points_percent / 100"
                    >
                    </ion-progress-bar>
                  </div>
                </ion-label>

                <ion-badge
                  [color]="pointsProgressBarColor"
                  slot="end"
                  *ngIf="
                    currentUser &&
                    userPoints &&
                    userPoints.pointsSystem &&
                    userPoints.pointsSystem.active > 0
                  "
                >
                  {{
                    userPoints.pointsSystem.active
                      ? userPoints.pointsSystem.active
                      : "0"
                  }}
                </ion-badge>
              </ion-item>
              <!-- discount-coupons -->
              <ion-item
                button
                *ngIf="
                  currentUser &&
                  !store_info?.only_visitors_app &&
                  groupApp &&
                  groupApp.couponsPage
                "
                (click)="pageChange('discount-coupons')"
                lines="none"
                detail="false"
                [class.selected]="selectedIndex === 'discount-coupons'"
                [color]="
                  selectedIndex === 'discount-coupons'
                    ? ''
                    : 'customSideMenuItemBackground'
                "
              >
                <ion-icon
                  slot="start"
                  style="margin-right: 20px"
                  [ios]="'ticket' + '-outline'"
                  [md]="'ticket' + '-sharp'"
                ></ion-icon>
                <ion-label>{{
                  "pages.discount-coupons" | translate
                }}</ion-label>
                <ion-badge
                  *ngIf="
                    activeCoupons &&
                    activeCoupons.length &&
                    activeCoupons.length > 0
                  "
                  slot="end"
                  color="ionMenuBadgesColor"
                  >{{ activeCoupons.length }}</ion-badge
                >
              </ion-item>

              <!-- Contests Page -->

              <ion-item
                button
                *ngIf="
                  groupApp &&
                  !store_info?.only_visitors_app &&
                  groupApp.contestSystemEnabled
                "
                (click)="pageChange('contests')"
                lines="none"
                detail="false"
                [class.selected]="selectedIndex === 'contests'"
                [color]="
                  selectedIndex === 'contests'
                    ? ''
                    : 'customSideMenuItemBackground'
                "
                [hidden]="currentUser && currentUser.uposMoUser"
              >
                <ion-icon
                  slot="start"
                  style="margin-right: 20px"
                  [ios]="'trophy' + '-outline'"
                  [md]="'trophy' + '-sharp'"
                ></ion-icon>
                <ion-label>{{ "pages.contests" | translate }}</ion-label>
                <ion-badge
                  *ngIf="activeDrawsNumber && activeDrawsNumber > 0"
                  slot="end"
                  color="ionMenuBadgesColor"
                >
                  {{ activeDrawsNumber }}</ion-badge
                >
              </ion-item>

              <!-- delivery areas -->
              <ion-item
                *ngIf="
                  !store_info?.only_visitors_app &&
                  currentStore &&
                  !currentStore.disableDeliveryAreas
                "
                button
                (click)="pageChange('deliveryAreas')"
                lines="none"
                detail="false"
                [class.selected]="selectedIndex === 'deliveryAreas'"
                [color]="
                  selectedIndex === 'deliveryAreas'
                    ? ''
                    : 'customSideMenuItemBackground'
                "
              >
                <ion-icon
                  slot="start"
                  style="margin-right: 20px"
                  [ios]="'map' + '-outline'"
                  [md]="'map' + '-sharp'"
                >
                </ion-icon>
                <ion-label>{{ "pages.delivery-areas" | translate }}</ion-label>
              </ion-item>
              <!-- loyalty system -->
              <ion-item
                *ngIf="
                  !store_info?.only_visitors_app &&
                  currentStore &&
                  groupApp.active_loyalty_app
                "
                button
                (click)="pageChange('loyaltySystem')"
                lines="none"
                detail="false"
                [class.selected]="selectedIndex === 'loyaltySystem'"
                [color]="
                  selectedIndex === 'loyaltySystem'
                    ? ''
                    : 'customSideMenuItemBackground'
                "
                [hidden]="currentUser && currentUser.uposMoUser"
              >
                <ion-icon
                  slot="start"
                  style="margin-right: 20px"
                  name="star-outline"
                ></ion-icon>
                <ion-label>{{ "pages.loyalty-system" | translate }}</ion-label>
              </ion-item>
              <!-- ratings -->
              <ion-item
                *ngIf="
                  !store_info?.only_visitors_app &&
                  currentUser &&
                  stores &&
                  ((stores.length === 1 && stores[0].reviewSystemActivated) ||
                    stores.length > 1)
                "
                (click)="pageChange('ratings')"
                lines="none"
                button
                detail="false"
                [class.selected]="selectedIndex === 'ratings'"
                [color]="
                  selectedIndex === 'ratings'
                    ? ''
                    : 'customSideMenuItemBackground'
                "
                (click)="pageChange('ratings')"
                lines="none"
                button
                detail="false"
                [class.selected]="selectedIndex === 'ratings'"
                [hidden]="currentUser && currentUser.uposMoUser"
              >
                <ion-icon
                  slot="start"
                  style="margin-right: 20px"
                  [ios]="'star-half' + '-outline'"
                  [md]="'star-half' + '-sharp'"
                ></ion-icon>
                <ion-label>{{ "pages.ratings" | translate }}</ion-label>
              </ion-item>
              <!-- store schedule -->
              <ion-item
                button
                (click)="pageChange('storeSchedule')"
                lines="none"
                detail="false"
                [class.selected]="selectedIndex === 'storeSchedule'"
                [color]="
                  selectedIndex === 'storeSchedule'
                    ? ''
                    : 'customSideMenuItemBackground'
                "
                [hidden]="currentUser && currentUser.uposMoUser"
              >
                <ion-icon
                  slot="start"
                  style="margin-right: 20px"
                  [ios]="'information' + '-outline'"
                  [md]="'information' + '-sharp'"
                ></ion-icon>
                <ion-label>{{ "pages.store-schedule" | translate }}</ion-label>
              </ion-item>
              <!-- payment terms -->
              <ion-item
                button
                *ngIf="stores && showPaymentTerms"
                (click)="pageChange('payment-terms')"
                lines="none"
                detail="false"
                [class.selected]="selectedIndex === 'payment-terms'"
                [color]="
                  selectedIndex === 'payment-terms'
                    ? ''
                    : 'customSideMenuItemBackground'
                "
                [hidden]="currentUser && currentUser.uposMoUser"
              >
                <ion-icon
                  style="margin-right: 20px"
                  slot="start"
                  [ios]="'clipboard' + '-outline'"
                  [md]="'clipboard' + '-sharp'"
                ></ion-icon>
                <ion-label>{{ "pages.payment-terms" | translate }}</ion-label>
              </ion-item>
              <ion-item
                button
                *ngFor="let customPage of customPagesMenu"
                (click)="openCustomPage(customPage.id)"
                lines="none"
                detail="false"
                [class.selected]="
                  selectedIndex === 'custom-page-' + customPage.id
                "
                [color]="
                  selectedIndex === 'custom-page-' + customPage.id
                    ? ''
                    : 'customSideMenuItemBackground'
                "
              >
                <ion-icon
                  style="margin-right: 20px"
                  slot="start"
                  [ios]="customPage.iconIos"
                  [md]="customPage.iconMd"
                ></ion-icon>
                <ion-label>{{ customPage.label }}</ion-label>
              </ion-item>
              <!-- logout -->
              <ion-item
                color="customSideMenuItemBackground"
                button
                *ngIf="currentUser"
                (click)="logout()"
                lines="none"
                detail="false"
              >
                <ion-icon
                  style="margin-right: 20px"
                  slot="start"
                  [ios]="'log-out' + '-outline'"
                  [md]="'log-out' + '-sharp'"
                ></ion-icon>
                <ion-label>{{ "pages.logout" | translate }}</ion-label>
              </ion-item>
            </ion-list>

            <ion-list
              style="padding: 0"
              *ngIf="
                loginState === 'login_completed' &&
                currentUser &&
                (currentUser.only_dinein || currentUser.only_visitor)
              "
            >
              <!-- catalog -->
              <ion-item
                button
                *ngIf="
                  groupApp?.design_settings?.hideSideCatalogMenuButton !== true &&
                  ((stores && stores.length === 1) || currentStore) &&
                  ((currentStore && !currentStore.showOnlyFavoritesCatalog) ||
                    (currentStore &&
                      currentStore.showOnlyFavoritesCatalog &&
                      currentUser))
                "
                (click)="pageChange('catalog')"
                lines="none"
                detail="false"
                [class.selected]="selectedIndex === 'catalog'"
                [color]="
                  selectedIndex === 'catalog'
                    ? ''
                    : 'customSideMenuItemBackground'
                "
              >
                <ion-icon
                  slot="start"
                  style="margin-right: 20px"
                  [ios]="'list' + '-outline'"
                  [md]="'list' + '-sharp'"
                >
                </ion-icon>

                <ion-label>
                  <ion-text
                    *ngIf="
                      !groupApp.design_settings ||
                      !groupApp.design_settings
                        .sideCatalogMenuButtonCustomTextEnabled ||
                      (groupApp.design_settings &&
                        groupApp.design_settings
                          .sideCatalogMenuButtonCustomTextEnabled &&
                        (!groupApp.design_settings
                          .sideCatalogMenuButtonCustomText ||
                          !groupApp.design_settings
                            .sideCatalogMenuButtonCustomText[selectedLanguage]))
                    "
                  >
                    {{ "pages.catalog" | translate }}
                  </ion-text>

                  <ion-text
                    *ngIf="
                      groupApp.design_settings &&
                      groupApp.design_settings
                        .sideCatalogMenuButtonCustomTextEnabled &&
                      groupApp.design_settings
                        .sideCatalogMenuButtonCustomText &&
                      groupApp.design_settings.sideCatalogMenuButtonCustomText[
                        selectedLanguage
                      ]
                    "
                  >
                    {{
                      groupApp.design_settings.sideCatalogMenuButtonCustomText[
                        selectedLanguage
                      ]
                    }}
                  </ion-text>
                  <div
                    *ngIf="
                      stores &&
                      stores.length > 1 &&
                      currentStore &&
                      currentStore.store_name &&
                      selectedLanguage
                    "
                    style="font-size: small; opacity: 0.7"
                  >
                    <ion-text>
                      {{
                        currentStore.store_name_mobileorder &&
                        currentStore.store_name_mobileorder[selectedLanguage]
                          ? currentStore.store_name_mobileorder[
                              selectedLanguage
                            ]
                          : currentStore.store_name_langs &&
                            currentStore.store_name_langs[selectedLanguage]
                          ? currentStore.store_name_langs[selectedLanguage]
                          : currentStore.store_name_langs &&
                            currentStore.store_name_langs.el
                          ? currentStore.store_name_langs.el
                          : currentStore.store_name
                      }}
                    </ion-text>
                  </div>
                </ion-label>
              </ion-item>

              <!-- cart -->
              <ion-item
                button
                *ngIf="cartProducts && cartProducts.length > 0"
                (click)="pageChange('cart')"
                lines="none"
                detail="false"
                [class.selected]="selectedIndex === 'cart'"
                [color]="
                  selectedIndex === 'cart' ? '' : 'customSideMenuItemBackground'
                "
              >
                <ion-icon
                  slot="start"
                  style="margin-right: 20px"
                  [ios]="'cart' + '-outline'"
                  [md]="'cart' + '-sharp'"
                >
                </ion-icon>
                <ion-label>
                  {{ "pages.cart" | translate }}
                </ion-label>
                <ion-badge
                  *ngIf="cartProductsNumber"
                  slot="end"
                  color="ionMenuBadgesColor"
                  >{{ cartProductsNumber }}</ion-badge
                >
              </ion-item>

              <!-- orders -->
              <ion-item
                button
                *ngIf="currentUser"
                (click)="pageChange('orders')"
                lines="none"
                detail="false"
                [class.selected]="selectedIndex === 'orders'"
                [color]="
                  selectedIndex === 'orders'
                    ? ''
                    : 'customSideMenuItemBackground'
                "
              >
                <ion-icon
                  slot="start"
                  style="margin-right: 20px"
                  [ios]="'reader' + '-outline'"
                  [md]="'reader' + '-sharp'"
                ></ion-icon>
                <ion-label>{{ "pages.orders" | translate }}</ion-label>
              </ion-item>

              <!-- payment terms -->
              <ion-item
                button
                *ngIf="stores && showPaymentTerms"
                (click)="pageChange('payment-terms')"
                lines="none"
                detail="false"
                [class.selected]="selectedIndex === 'payment-terms'"
                [color]="
                  selectedIndex === 'payment-terms'
                    ? ''
                    : 'customSideMenuItemBackground'
                "
              >
                <ion-icon
                  style="margin-right: 20px"
                  slot="start"
                  [ios]="'clipboard' + '-outline'"
                  [md]="'clipboard' + '-sharp'"
                ></ion-icon>
                <ion-label>{{ "pages.payment-terms" | translate }}</ion-label>
              </ion-item>

              <ion-item
                button
                *ngFor="let customPage of customPagesMenu"
                (click)="openCustomPage(customPage.id)"
                lines="none"
                detail="false"
                [class.selected]="
                  selectedIndex === 'custom-page-' + customPage.id
                "
                [color]="
                  selectedIndex === 'custom-page-' + customPage.id
                    ? ''
                    : 'customSideMenuItemBackground'
                "
              >
                <ion-icon
                  style="margin-right: 20px"
                  slot="start"
                  [ios]="customPage.iconIos"
                  [md]="customPage.iconMd"
                ></ion-icon>
                <ion-label>{{ customPage.label }}</ion-label>
              </ion-item>

              <!-- logout -->
              <ion-item
                color="customSideMenuItemBackground"
                button
                *ngIf="currentUser"
                (click)="logout()"
                lines="none"
                detail="false"
              >
                <ion-icon
                  style="margin-right: 20px"
                  slot="start"
                  [ios]="'log-out' + '-outline'"
                  [md]="'log-out' + '-sharp'"
                ></ion-icon>
                <ion-label>{{ "pages.new-order" | translate }}</ion-label>
              </ion-item>
            </ion-list>
          </ion-menu-toggle>
        </ion-list>
      </ion-content>

      <app-menu-footer
        [appChannel]="appChannel"
        [version]="version"
      ></app-menu-footer>
    </ion-menu>
    <ion-router-outlet
      queryParamsHandling="merge"
      [swipeGesture]="false"
      *ngIf="
        groupApp &&
        (!groupApp.splash_screen_active ||
          !groupApp.splashScreenImage ||
          (groupApp.splash_screen_active &&
            groupApp.splashScreenImage &&
            splashScreenDissmised))
      "
      id="main-content"
      animated="false"
    ></ion-router-outlet>
  </ion-split-pane>
  <ion-router-outlet
    queryParamsHandling="merge"
    [swipeGesture]="false"
    *ngIf="
      groupApp &&
      groupApp.only_loyalty_app &&
      groupTheme &&
      appInitLoadingStep &&
      appInitLoadingStep === 'app-loaded' &&
      (!groupApp.splash_screen_active ||
        !groupApp.splashScreenImage ||
        (groupApp.splash_screen_active &&
          groupApp.splashScreenImage &&
          splashScreenDissmised))
    "
    id="main-content"
    animated="false"
  ></ion-router-outlet>
  <ion-router-outlet
    queryParamsHandling="merge"
    [swipeGesture]="false"
    *ngIf="
      groupApp &&
      groupApp.active_reservation_app &&
      groupTheme &&
      appInitLoadingStep &&
      appInitLoadingStep === 'app-loaded' &&
      (!groupApp.splash_screen_active ||
        !groupApp.splashScreenImage ||
        (groupApp.splash_screen_active &&
          groupApp.splashScreenImage &&
          splashScreenDissmised))
    "
    id="main-content"
    animated="false"
  ></ion-router-outlet>
  <div
    *ngIf="
      showCookiesConsentBanner &&
      groupTheme &&
      appInitLoadingStep &&
      appInitLoadingStep === 'app-loaded'
    "
    class="cookiesConsentBannerWrapper"
  >
    <div class="cookiesConsentBannerCard">
      <div class="cookiesConsentBannerContent">
        <div class="cookiesConsentBannerTitle">
          {{ "cookies-consent.title" | translate }}
        </div>
        <div class="cookiesConsentBannerDescription">
          {{ "cookies-consent.description" | translate }}
        </div>
        <div class="cookiesConsentBannerMetaRow">
          <button
            type="button"
            class="cookiesConsentBannerLink"
            (click)="openCookiesConsentPolicy()"
          >
            {{ "cookies-consent.privacy-policy" | translate }}
          </button>
        </div>
      </div>

      <div class="cookiesConsentBannerActions">
        <ion-button
          fill="clear"
          class="cookiesConsentSecondaryButton"
          (click)="dismissCookiesConsentBanner('necessary')"
        >
          {{ "cookies-consent.only-necessary" | translate }}
        </ion-button>
        <ion-button
          class="cookiesConsentPrimaryButton"
          (click)="dismissCookiesConsentBanner('all')"
        >
          {{ "cookies-consent.accept-all" | translate }}
        </ion-button>
      </div>
    </div>
  </div>
</ion-app>
